export const LOAD_PROFILE = 'LOAD_PROFILE';
export const REMOVE_PROFILE = 'REMOVE_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const CREATE_PROFILE_LOCATION = 'CREATE_PROFILE_LOCATION'
export const UPDATE_PROFILE_LOCATION = 'UPDATE_PROFILE_LOCATION'
export const CREATE_NEW_CONVERSATION = 'CREATE_NEW_CONVERSATION'
export const ADD_LOCATION_IMAGES = "ADD_LOCATION_IMAGES";
export const REMOVE_LOCATION_IMAGES = "REMOVE_LOCATION_IMAGES";
export const BLOCK_USER = 'BLOCK_USER';
export const UNBLOCK_USER = 'UNBLOCK_USER';